import { Pagination } from 'antd';
import s from './index.module.css';
import zhCN from 'antd/es/locale/zh_CN';

const CommonPagination = ({
  current = 1,
  pageSize = 12,
  total = 0,
  onChange,
  onShowSizeChange,
  showSizeChanger = true,
  showQuickJumper = true,
  showTotal = true,
  pageSizeOptions = ['12', '24', '48', '96'],
  className = ''
}) => {
  const defaultShowTotal = (total, range) =>
    `第 ${range[0]}-${range[1]} 条，共 ${total} 条`;

  return (
    <div className={`${s.commonPagination} ${className}`}>
      <Pagination
        current={current}
        pageSize={pageSize}
        total={total}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showSizeChanger={showSizeChanger}
        showQuickJumper={showQuickJumper}
        showTotal={showTotal ? defaultShowTotal : false}
        pageSizeOptions={pageSizeOptions}
        size="default"
        locale={zhCN}
      />
    </div>
  );
};

export default CommonPagination;